import { render, staticRenderFns } from "./tongue.vue?vue&type=template&id=37c533e0&scoped=true&"
import script from "./tongue.vue?vue&type=script&lang=ts&"
export * from "./tongue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c533e0",
  null
  
)

export default component.exports